import { CmsPersonalDetailsForm } from './cms-personal-details-form.interface';

export interface CmsPersonalDetailsPage extends CmsPersonalDetailsForm {
  pageTitle: string;
}
